import type {
  CreateProjectTemplateRequest,
  CreateTemplateTaskRequest,
  ProjectTemplateDto,
  ProjectTemplateTaskDto,
  UpdateProjectTemplateRequest,
  UpdateTemplateTaskRequest,
} from '@ledokol/contracts'
import { api } from './client'

export async function fetchTemplates(): Promise<ProjectTemplateDto[]> {
  const r = await api.get<ProjectTemplateDto[]>('/project-templates')
  return r.data
}

export async function createTemplate(body: CreateProjectTemplateRequest): Promise<ProjectTemplateDto> {
  const r = await api.post<ProjectTemplateDto>('/project-templates', body)
  return r.data
}

export async function updateTemplate(
  id: string,
  body: UpdateProjectTemplateRequest,
): Promise<ProjectTemplateDto> {
  const r = await api.patch<ProjectTemplateDto>(`/project-templates/${id}`, body)
  return r.data
}

export async function deleteTemplate(id: string): Promise<void> {
  await api.delete(`/project-templates/${id}`)
}

export async function addTemplateTask(
  templateId: string,
  body: CreateTemplateTaskRequest,
): Promise<ProjectTemplateTaskDto> {
  const r = await api.post<ProjectTemplateTaskDto>(`/project-templates/${templateId}/tasks`, body)
  return r.data
}

export async function updateTemplateTask(
  taskId: string,
  body: UpdateTemplateTaskRequest,
): Promise<ProjectTemplateTaskDto> {
  const r = await api.patch<ProjectTemplateTaskDto>(`/project-template-tasks/${taskId}`, body)
  return r.data
}

export async function deleteTemplateTask(taskId: string): Promise<void> {
  await api.delete(`/project-template-tasks/${taskId}`)
}
